import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';
export const onActivity = createAction(`${reduxKey}.DAMZ_GLOBAL_ACTIVITY`, (room_id)=>({
        room_id
    }));
export const addActivityQueue = createAction(`${reduxKey}.DAMZ_GLOBAL_ACTIVITY_ENQUEUE`, (room_id)=>({
        room_id
    }));
export const clearActivityQueue = createAction(`${reduxKey}.DAMZ_GLOBAL_ACTIVITY_CLEAR`, ()=>({}));
export const sendAlertAndUpdateDrawer = createAction(`${reduxKey}.DAMZ_GLOBAL_ACTIVITY_ALERTS`, ()=>({}));

//# sourceMappingURL=global.js.map